export default __webpack_public_path__ + "static/media/group-169@3x.70be06be.png";